export default "__VITE_ASSET__BHF$zBG6__"